export default __webpack_public_path__ + "static/media/norwester.696306af.otf";